import { CheckCircleOutlined, ClockCircleOutlined, WarningOutlined } from '@ant-design/icons';

import { EParticipantsImportStatus } from '@/api/endpoints/schools/schoolParticipants';

export const IMPORT_STATUS_TO_TAG_SETTINGS = {
  [EParticipantsImportStatus.Completed]: {
    text: 'Завершен',
    color: 'green',
    icon: <CheckCircleOutlined />,
  },
  [EParticipantsImportStatus.Processing]: {
    text: 'В процессе',
    color: 'gold',
    icon: <ClockCircleOutlined />,
  },
  [EParticipantsImportStatus.Pending]: {
    text: 'Ожидает обработки',
    color: 'gold',
    icon: <ClockCircleOutlined />,
  },
  [EParticipantsImportStatus.PartiallyCompleted]: {
    text: 'Завершен частично',
    color: 'gold',
    icon: <WarningOutlined />,
  },
};
